

export const BdcPage = () => {
    return (
        <div>
            <h2>BdcPage</h2>
        </div>
    )
}

export default BdcPage